import { h } from 'preact'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'
import Phrase from '../../../libs/translationsUtils/phrase'

type Hit = {
  label: string,
  value: string,
  count:number,
  isRefined: boolean
}

interface Props {
  items: Array<Hit>,
  isFromSearch: boolean,
  refine: (val: string) => void,
  searchForItems: (val: string) => void,
  createURL: (val: string) => string
}

const List = ({
  items,
  isFromSearch,
  refine,
  createURL
}: Props) => (
  <div>
    <h4><Phrase p='Tags' /></h4>
    <ul class='instant-search-tags-filter public-tags list list--float'>
      {items.map(item => (
        <li key={item.label}>
          <a
            class={`tag--pill qa-tag-pill ${item.isRefined ? 'tag--active' : ''}`}
            href={createURL(item.value)}
            onClick={event => {
              event.preventDefault()
              refine(item.value)
            }}
          >
            {isFromSearch ? (
              <Highlight attribute='label' hit={item} />
            ) : (
            item.label
            )}{' '}
            ({item.count})
          </a>
        </li>
      ))}
    </ul>
  </div>
)

export default connectRefinementList(List)
